import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { isDefined } from "@omni/utils/helper.utils";
import { isEmpty } from "lodash-es";
import { useEffect, useState } from "react";

import { useBFFProductServiceApi } from "@/api/hooks/productService.hook";
import { ProductSliderComponent } from "@/components/Product/ProductSlider/productSlider.component";

import { useProductSliderContext } from "../productSlider.context";
import { ProductSliderSkeletonComponent } from "../skeleton/productSliderSkeleton.component";

const extractAccessoires = (product?: Product<ProductFieldSet.Full>) => {
    const accessories = product?.references?.accessories;
    if (!accessories) return [];

    return accessories.filter(isDefined);
};

export type AccessoriesProductSliderProps = {
    sku: string;
};

const AccessoriesProductSlider = ({ sku }: AccessoriesProductSliderProps) => {
    const { prefetchedProducts } = useProductSliderContext();

    const [products, setProducts] = useState(prefetchedProducts);

    const [{ loading, error }, loadProducts] = useBFFProductServiceApi<
        any,
        any,
        Array<Product<ProductFieldSet.Full>>
    >(
        {
            url: `/products`,
            method: "GET"
        },
        {
            manual: true,
            useCache: false,
            autoCancel: false
        }
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (!sku) return;
        if (isDefined(products)) return;
        if (loading || error) return;

        loadProducts({
            params: {
                sku: sku,
                fields: ProductFieldSet.Full
            }
        })
            .then(({ data }) => data?.at(0))
            .then(extractAccessoires)
            .then(setProducts);
    }, [products, sku, loading, error, loadProducts, setProducts]);

    if (!sku || error) {
        return null;
    } else if (isDefined(products) && isEmpty(products)) {
        return null;
    } else if (isDefined(products) && !isEmpty(products)) {
        return <ProductSliderComponent products={products} />;
    } else {
        return <ProductSliderSkeletonComponent />;
    }
};

export { AccessoriesProductSlider };
